import styles from "./icon.module.css";

export default function Icon({src, alt = ''}) {
    return <div className={styles.icon}><img src={src} alt={alt} /></div>
}